<div class="fixed inset-0 z-[1000] flex items-center justify-center" id="modal">
    <input>
      <label>mecanico1</label>
      <label>mecanico2</label>
<div>